// Minimal but correct CSV parser — handles quoted fields, escaped quotes (""),
// embedded commas and newlines, and CRLF. Returns headers + string rows.
export interface ParsedCsv { headers: string[]; rows: string[][] }

export function parseCsv(text: string): ParsedCsv {
  const records: string[][] = [];
  let field = '';
  let row: string[] = [];
  let inQuotes = false;
  const s = text.replace(/^﻿/, ''); // strip BOM

  for (let i = 0; i < s.length; i++) {
    const ch = s[i];
    if (inQuotes) {
      if (ch === '"') {
        if (s[i + 1] === '"') { field += '"'; i++; }
        else inQuotes = false;
      } else field += ch;
    } else if (ch === '"') {
      inQuotes = true;
    } else if (ch === ',') {
      row.push(field); field = '';
    } else if (ch === '\n' || ch === '\r') {
      if (ch === '\r' && s[i + 1] === '\n') i++;
      row.push(field); field = '';
      if (row.length > 1 || row[0] !== '') records.push(row);
      row = [];
    } else field += ch;
  }
  if (field !== '' || row.length) { row.push(field); if (row.length > 1 || row[0] !== '') records.push(row); }

  if (!records.length) return { headers: [], rows: [] };
  const headers = records[0].map((h) => h.trim());
  return { headers, rows: records.slice(1) };
}

// Platform fields a CSV column can map to.
export const IMPORT_FIELDS = [
  { key: 'businessName', label: 'Business name' },
  { key: 'contactName', label: 'Person name' },
  { key: 'companyName', label: 'Company' },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Phone' },
  { key: 'website', label: 'Website' },
  { key: 'title', label: 'Job title' },
  { key: 'address', label: 'Address' },
] as const;

export type ImportField = (typeof IMPORT_FIELDS)[number]['key'];

// Best-guess mapping from a CSV header to a platform field.
export function guessField(header: string): ImportField | '' {
  const h = header.toLowerCase().replace(/[^a-z]/g, '');
  if (/(^|_)email|mail/.test(h)) return 'email';
  if (/phone|mobile|cell|tel/.test(h)) return 'phone';
  if (/website|url|site|domain/.test(h)) return 'website';
  if (/title|role|position/.test(h)) return 'title';
  if (/address|street|city|state|zip/.test(h)) return 'address';
  if (/company|organization|org|account/.test(h)) return 'companyName';
  if (/business|dba/.test(h)) return 'businessName';
  if (/(first|last|full|contact).*name|^name$|person/.test(h)) return 'contactName';
  return '';
}
